"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDetails = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var lodash_isempty_1 = __importDefault(require("lodash.isempty"));
var mime_types_1 = __importDefault(require("mime-types"));
var pretty_bytes_1 = __importDefault(require("pretty-bytes"));
var react_1 = __importStar(require("react"));
var strip_extension_1 = __importDefault(require("strip-extension"));
var use_associations_1 = require("../../hooks/use-associations");
var use_download_file_1 = require("../../hooks/use-download-file");
var use_update_file_1 = require("../../hooks/use-update-file");
var date_1 = require("../../lib/date");
var document_types_1 = require("../../lib/document-types");
var download_email_filename_1 = require("../../lib/download-email-filename");
var get_gmail_url_1 = require("../../lib/get-gmail-url");
var email_details_1 = require("../email-details");
var email_details_actions_1 = require("../email-details-actions");
var file_associations_1 = require("../file-associations");
var file_status_badge_1 = require("../file-status-badge");
function FileDetails(_a) {
    var _this = this;
    var _b, _c;
    var file = _a.file, onChange = _a.onChange, _d = _a.hideEmailDetails, hideEmailDetails = _d === void 0 ? false : _d, documentTypes = _a.documentTypes, fileStatus = _a.fileStatus;
    var _e = (0, react_1.useState)(false), updated = _e[0], setUpdated = _e[1];
    var _f = (0, react_1.useState)(file.category || 'Unknown'), updatedDocType = _f[0], setUpdatedDocType = _f[1];
    var updateFile = (0, use_update_file_1.useUpdateFile)()[0];
    var downloadFile = (0, use_download_file_1.useDownloadFile)()[0];
    var _g = (0, react_1.useState)(), createdByUser = _g[0], setCreatedByUser = _g[1];
    var _h = (0, react_1.useState)(), updatedByUser = _h[0], setUpdatedByUser = _h[1];
    var _j = (0, react_1.useState)(), objectRefs = _j[0], setObjectRefs = _j[1];
    var isEmail = ((_b = file.category) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'email';
    var fetchAssociations = (0, use_associations_1.useAssociations)()[0];
    var handleEmailDownload = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, downloadFile(file.id, 'attachment', false, isEmail ? (0, download_email_filename_1.getDownloadEmailFilename)(file.id, file.filename) : undefined)];
        });
    }); }, [downloadFile, file.id, isEmail]);
    var handleOpenInGmail = (0, react_1.useCallback)(function () {
        return (0, get_gmail_url_1.getGmailUrl)(file.meta);
    }, [file]);
    var handleFilenameUpdate = (0, react_1.useCallback)(function (updatedFilenameWithoutExtension) { return __awaiter(_this, void 0, void 0, function () {
        var updatededFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateFile({
                        id: file.id,
                        filename: "".concat(updatedFilenameWithoutExtension, ".").concat(mime_types_1.default.extension(file.contentType)),
                    })];
                case 1:
                    updatededFile = _a.sent();
                    setUpdated(true);
                    if (!onChange || !updatededFile)
                        return [2 /*return*/];
                    onChange(updatededFile === null || updatededFile === void 0 ? void 0 : updatededFile.file);
                    return [2 /*return*/];
            }
        });
    }); }, [onChange, file, updateFile]);
    var handleSummaryUpdate = (0, react_1.useCallback)(function (updatedSummary) { return __awaiter(_this, void 0, void 0, function () {
        var updatededFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateFile({
                        id: file.id,
                        meta: __assign(__assign({}, file === null || file === void 0 ? void 0 : file.meta), { summary: updatedSummary }),
                    })];
                case 1:
                    updatededFile = _a.sent();
                    setUpdated(true);
                    // if we dont have an onChange fn (e.g. file-details view), or an updated file...get out.
                    if (!onChange || !updatededFile)
                        return [2 /*return*/];
                    onChange(updatededFile === null || updatededFile === void 0 ? void 0 : updatededFile.file);
                    return [2 /*return*/];
            }
        });
    }); }, [onChange, file, updateFile]);
    var handleDocTypeUpdate = (0, react_1.useCallback)(function (docType) { return __awaiter(_this, void 0, void 0, function () {
        var updatededFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateFile({
                        id: file.id,
                        category: docType,
                        meta: file === null || file === void 0 ? void 0 : file.meta,
                    })];
                case 1:
                    updatededFile = _a.sent();
                    setUpdated(true);
                    // if we dont have an onChange fn (e.g. file-details view), or an updated file...get out.
                    if (!onChange || !updatededFile)
                        return [2 /*return*/];
                    onChange(updatededFile === null || updatededFile === void 0 ? void 0 : updatededFile.file);
                    return [2 /*return*/];
            }
        });
    }); }, [onChange, file, updateFile]);
    (0, react_1.useEffect)(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, createdBy, updatedBy, objectRefAssociations;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                fetchAssociations({ user: [file.createdByUserId] }),
                                fetchAssociations({ user: [file.updatedByUserId] }),
                                fetchAssociations(file.objectRefs),
                            ])];
                        case 1:
                            _a = _b.sent(), createdBy = _a[0], updatedBy = _a[1], objectRefAssociations = _a[2];
                            setCreatedByUser(createdBy);
                            setUpdatedByUser(updatedBy);
                            setObjectRefs(objectRefAssociations);
                            return [2 /*return*/];
                    }
                });
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchData();
    }, [file]);
    return (react_1.default.createElement(core_ui_1.Padding, { size: 32, top: 48 },
        updated && (react_1.default.createElement(core_ui_1.Padding, { bottom: 24, top: hideEmailDetails ? 0 : 12 },
            react_1.default.createElement(core_ui_1.Alert, null, "Updates to this file may take a few minutes to persist in the files table."))),
        react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "baseline" },
            react_1.default.createElement(core_ui_1.Text, { color: core_ui_1.colors.steel[300] }, "Filename"),
            react_1.default.createElement(core_ui_1.Spacing, { width: 4 }),
            react_1.default.createElement(core_ui_1.Text, { size: "small", color: core_ui_1.colors.steel[300] }, "(editable)")),
        react_1.default.createElement(core_ui_1.Title, { size: 24, weight: 400 },
            react_1.default.createElement(core_ui_1.ContentEditable, { saveAnimation: true, value: (0, strip_extension_1.default)(file.filename), placeholder: "Untitled file", disabled: false, onUpdate: handleFilenameUpdate })),
        react_1.default.createElement(core_ui_1.Spacing, { height: 24 }),
        react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "baseline" },
            react_1.default.createElement(core_ui_1.Text, { color: core_ui_1.colors.steel[300] }, "Summary"),
            react_1.default.createElement(core_ui_1.Spacing, { width: 4 }),
            react_1.default.createElement(core_ui_1.Text, { size: "small", color: core_ui_1.colors.steel[300] }, "(editable)")),
        react_1.default.createElement(core_ui_1.Spacing, { height: 4 }),
        react_1.default.createElement(core_ui_1.Title, { size: 17, weight: 400 },
            react_1.default.createElement(core_ui_1.ContentEditable, { saveAnimation: true, value: ((_c = file === null || file === void 0 ? void 0 : file.meta) === null || _c === void 0 ? void 0 : _c.summary) || '', placeholder: "Untitled file", disabled: false, onUpdate: handleSummaryUpdate })),
        react_1.default.createElement(core_ui_1.Spacing, { height: 24 }),
        react_1.default.createElement(core_ui_1.Flexbox, { width: "100%" },
            react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column", width: "50%" },
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Doc type")),
                    react_1.default.createElement(core_ui_1.SelectInput, { onChange: function (docType) {
                            setUpdatedDocType(docType);
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            handleDocTypeUpdate(docType);
                        }, options: (0, document_types_1.createDocumentTypeOptions)(documentTypes), showSelectAnOption: true, value: (0, document_types_1.getDocumentTypeOption)(updatedDocType, documentTypes) })),
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Size")),
                    react_1.default.createElement(core_ui_1.Text, { color: "dark" }, (0, pretty_bytes_1.default)(parseFloat(file.contentLength || '0')))),
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Created")),
                    react_1.default.createElement(core_ui_1.Text, { color: "dark" }, (0, date_1.longDateTimeFormatWithTimeZone)(file.createdAt))),
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Uploaded")),
                    react_1.default.createElement(core_ui_1.Text, { color: "dark" }, (0, date_1.longDateTimeFormatWithTimeZone)(file.createdAt))),
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Modified")),
                    react_1.default.createElement(core_ui_1.Text, { color: "dark" }, (0, date_1.longDateTimeFormatWithTimeZone)(file.updatedAt)))),
            react_1.default.createElement(core_ui_1.Spacing, { width: 24 }),
            react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column", width: "50%" },
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Extension type")),
                    react_1.default.createElement(core_ui_1.Text, { color: "dark" }, mime_types_1.default.extension(file.contentType || '') || 'unknown')),
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Source")),
                    react_1.default.createElement(core_ui_1.Text, { color: "dark" }, "-")),
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Uploaded by")),
                    !createdByUser && react_1.default.createElement(core_ui_1.CircleSpinnerInline, null),
                    createdByUser && createdByUser.length > 0 && (react_1.default.createElement(file_associations_1.Associations, { associations: createdByUser }))),
                react_1.default.createElement(core_ui_1.Padding, { bottom: 16 },
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Updated by")),
                    !updatedByUser && react_1.default.createElement(core_ui_1.CircleSpinnerInline, null),
                    updatedByUser && updatedByUser.length > 0 && (react_1.default.createElement(file_associations_1.Associations, { associations: updatedByUser }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                        react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Status")),
                    react_1.default.createElement(file_status_badge_1.FileStatusBadge, { status: fileStatus || file.status })))),
        react_1.default.createElement(core_ui_1.Padding, { top: 24 },
            react_1.default.createElement(core_ui_1.Padding, { bottom: 4 },
                react_1.default.createElement(core_ui_1.Text, { truncate: true, nowrap: true, color: "light", size: "small" }, "Associations")),
            !objectRefs && react_1.default.createElement(core_ui_1.CircleSpinnerInline, null),
            objectRefs && objectRefs.length > 0 && react_1.default.createElement(file_associations_1.Associations, { associations: objectRefs })),
        isEmail && !hideEmailDetails && (!file.meta || (0, lodash_isempty_1.default)(file.meta)) && (react_1.default.createElement(core_ui_1.Padding, { top: 24 },
            react_1.default.createElement(core_ui_1.Box, { border: 1, boxShadow: "card", backgroundColor: "white" },
                react_1.default.createElement(core_ui_1.Padding, { size: 16 },
                    react_1.default.createElement(core_ui_1.Text, null, "There is no metadata for this email."))))),
        isEmail && !hideEmailDetails && !(0, lodash_isempty_1.default)(file.meta) && (react_1.default.createElement(core_ui_1.Padding, { top: 24 },
            react_1.default.createElement(core_ui_1.Padding, { bottom: 24 },
                react_1.default.createElement(email_details_actions_1.EmailDetailsActions, { handleEmailDownload: handleEmailDownload, handleOpenInGmail: handleOpenInGmail })),
            react_1.default.createElement(core_ui_1.Box, { border: 1, boxShadow: "card", backgroundColor: "white" },
                react_1.default.createElement(core_ui_1.Padding, { size: 16 },
                    react_1.default.createElement(email_details_1.EmailDetails, { file: file })))))));
}
exports.FileDetails = FileDetails;
